import { supabase } from "@/components/atomic-crm/providers/supabase/supabase";

/**
 * Storage objects are org-scoped by path: "{org_id}/..." (see migration
 * 20261012172000_storage_org_scoped_paths.sql). Storage RLS only lets a member
 * read or write objects whose first segment is their own org; unprefixed
 * legacy objects belong to the original org.
 */
let cachedOrgId: number | null = null;

// Optional chaining: unit tests mock the client without auth.
supabase.auth?.onAuthStateChange?.((event) => {
  if (event === "SIGNED_OUT" || event === "SIGNED_IN") cachedOrgId = null;
});

export const getCurrentOrgId = async (): Promise<number | null> => {
  if (cachedOrgId != null) return cachedOrgId;
  const { data, error } = await supabase.rpc("current_user_org_id");
  if (error || data == null) return null;
  cachedOrgId = Number(data);
  return Number.isFinite(cachedOrgId) ? cachedOrgId : null;
};

/** Prefixes a storage object name with the given (or current) org id. */
export const orgStoragePath = async (
  name: string,
  orgId?: string | number | null,
): Promise<string> => {
  const org =
    orgId != null && String(orgId).trim() !== "" && String(orgId) !== "unknown"
      ? String(orgId)
      : await getCurrentOrgId();
  return org != null ? `${org}/${name.replace(/^\/+/, "")}` : name;
};
